module.exports = __webpack_public_path__ + "static/media/landmark100exam.1e28422f.jpg";